import { useState } from "react";

import { PeriodicCampaignEditForm } from "src/app/features/PeriodicCampaign/components/forms/PeriodicCampaignEditForm";
import { usePeriodicCampaignLoadQuery } from "src/app/features/PeriodicCampaign/services/server/PeriodicCampaignApi";
import { ActionBar } from "../../../../components/ActionBar/ActionBar";
import { PageTitle } from "../../../../components/AppLayout/components/Content/components";
import { NoAccessLayout } from "../../../../components/AppLayout/components/Content/components/NoAccessLayout";
import { FPage, FPageContent, FPageHeader } from "../../../../components/AppLayout/components/FPageLayout";
import { HistoryButton } from "../../../../components/FeatureButtons/HistoryButton";
import { RefreshButton } from "../../../../components/FeatureButtons/RefreshButton";
import { SubmitButton } from "../../../../components/FeatureButtons/SubmitButton";
import { getAssignedDataGroup } from "../../../../core/router/auth";
import { canAccess } from "../../../../core/router/auth/permissions";
import { ResourceName } from "../../../../core/router/config/ResourceName";
import { FORM_ACTION } from "../../../../core/router/types/routerTypes";

export const PeriodicCampaignEditFormPage = () => {
    const [runSubmit, setRunSubmit] = useState(0);
    const triggerFormSubmit = () => setRunSubmit(runSubmit + 1);
    const hasWriteAccess = canAccess(ResourceName.PERIODIC_CAMPAIGN, "canWrite");
    const hasAccess = canAccess(ResourceName.PERIODIC_CAMPAIGN, "canRead");
    const { data: entity } = usePeriodicCampaignLoadQuery({});
    const dataGroup = getAssignedDataGroup();
    const historyUrl = entity?.id
        ? `${ResourceName.DATA_GROUPS}/${dataGroup?.code}/periodic-campaign/${entity.id}/${FORM_ACTION.HISTORY}`
        : undefined;

    return (
        <FPage>
            {hasAccess ? (
                <>
                    <FPageHeader>
                        <PageTitle translationKey="page.title.periodicCampaignsEditFormPage" />
                        {hasWriteAccess && (
                            <ActionBar>
                                <SubmitButton isDisabled={false} onClick={triggerFormSubmit} />
                                <HistoryButton url={historyUrl} />
                                <RefreshButton isDisabled={false} />
                            </ActionBar>
                        )}
                    </FPageHeader>
                    <FPageContent>
                        <PeriodicCampaignEditForm runSubmit={runSubmit} />
                    </FPageContent>
                </>
            ) : (
                <NoAccessLayout />
            )}
        </FPage>
    );
};
